import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Collapse,
  Drawer,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Logo from 'src/app/components/Logo';

const TopBarMobileDrawer = ({
  menuResponsive,
  toggleDrawer,
  listMenu,
  switchRoute,
  setMenuResponsive,
  openManageMobile,
  setOpenManageMobile,
  isManageActive,
  renderMobileMenuItem,
  isPathActive,
  mobileManageMenuItems,
  isStatisticsActive,
  isDevicePathActive,
  isDriverPathActive,
  isAdvertisementPathActive,
  canShowDeviceLookupMenu,
  isDeviceLookupActive
}) => {
  const [openSubmenus, setOpenSubmenus] = useState({
    statistics: isStatisticsActive,
    device: isDevicePathActive,
    driver: isDriverPathActive,
    advertisement: isAdvertisementPathActive
  });

  useEffect(() => {
    setOpenSubmenus({
      statistics: isStatisticsActive,
      device: isDevicePathActive,
      driver: isDriverPathActive,
      advertisement: isAdvertisementPathActive
    });
  }, [isStatisticsActive, isDevicePathActive, isDriverPathActive, isAdvertisementPathActive]);

  const toggleSubmenu = (key) => {
    setOpenSubmenus(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const renderManageItem = (item) => {
    if (item.isCollapse) {
      const isOpen = openSubmenus[item.type];
      return (
        <React.Fragment key={item.label}>
          <ListItem
            button
            style={{ paddingLeft: 32 }}
            onClick={() => toggleSubmenu(item.type)}
          >
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{
                style: {
                  fontWeight: isOpen ? 600 : 400,
                  color: isOpen ? '#D9042F' : '#475461'
                }
              }}
            />
            <ExpandMoreIcon
              style={{
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: '0.25s',
                color: isOpen ? '#D9042F' : '#475461'
              }}
            />
          </ListItem>
          <Collapse in={isOpen} timeout={250} unmountOnExit>
            <List component="div" disablePadding>
              {item.items.map(subItem =>
                renderMobileMenuItem(subItem, 48, true)
              )}
            </List>
          </Collapse>
        </React.Fragment>
      );
    }

    return renderMobileMenuItem(item);
  };

  return (
    <Drawer
      className="mobile-drawer"
      open={menuResponsive}
      anchor="left"
      onClose={toggleDrawer(false)}
      PaperProps={{ style: { width: '85vw' } }}
    >
      <div role="presentation">
        <Box display="flex" justifyContent="center" padding="16px 0">
          <Logo />
        </Box>

        <List>
          {listMenu.map(menu => (
            <ListItem
              button
              key={menu.value}
              onClick={() => {
                switchRoute(menu.link, menu.query);
                setMenuResponsive(false);
              }}
            >
              <ListItemText
                primary={menu.label}
                primaryTypographyProps={{
                  style: {
                    color: isPathActive(menu.link) ? '#D9042F' : '#475461',
                    fontWeight: isPathActive(menu.link) ? 600 : 400
                  }
                }}
              />
            </ListItem>
          ))}

          {mobileManageMenuItems.length > 0 && (
            <ListItem button onClick={() => setOpenManageMobile(value => !value)}>
              <ListItemText
                primary="Quản trị"
                primaryTypographyProps={{
                  style: {
                    color: isManageActive ? '#D9042F' : '#475461',
                    fontWeight: isManageActive ? 600 : 400
                  }
                }}
              />
              <ExpandMoreIcon
                style={{
                  transform: openManageMobile ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: '0.25s',
                  color: isManageActive ? '#D9042F' : '#475461'
                }}
              />
            </ListItem>
          )}

          <Collapse in={openManageMobile} timeout={250} unmountOnExit>
            <List component="div" disablePadding>
              {mobileManageMenuItems.map(renderManageItem)}
            </List>
          </Collapse>

          {canShowDeviceLookupMenu && (
            <ListItem
              button
              onClick={() => {
                switchRoute('/manage/device-lookup');
                setMenuResponsive(false);
              }}
            >
              <ListItemText
                primary="Tech Hub"
                primaryTypographyProps={{
                  style: {
                    color: isDeviceLookupActive ? '#D9042F' : '#475461',
                    fontWeight: isDeviceLookupActive ? 600 : 400
                  }
                }}
              />
            </ListItem>
          )}
        </List>
      </div>
    </Drawer>
  );
};

TopBarMobileDrawer.propTypes = {
  menuResponsive: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  listMenu: PropTypes.array.isRequired,
  switchRoute: PropTypes.func.isRequired,
  setMenuResponsive: PropTypes.func.isRequired,
  openManageMobile: PropTypes.bool.isRequired,
  setOpenManageMobile: PropTypes.func.isRequired,
  isManageActive: PropTypes.bool.isRequired,
  renderMobileMenuItem: PropTypes.func.isRequired,
  isPathActive: PropTypes.func.isRequired,
  mobileManageMenuItems: PropTypes.array.isRequired,
  isStatisticsActive: PropTypes.bool.isRequired,
  isDevicePathActive: PropTypes.bool.isRequired,
  isDriverPathActive: PropTypes.bool.isRequired,
  isAdvertisementPathActive: PropTypes.bool.isRequired,
  canShowDeviceLookupMenu: PropTypes.bool.isRequired,
  isDeviceLookupActive: PropTypes.bool.isRequired
};

export default TopBarMobileDrawer;
